import React from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import wizardsShape from 'core/components/wizard/shapes'
import { Card, ButtonGhost } from 'core/components/ui'
import TitleItem from 'core/layouts/title-item'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'
import styled from 'styled-components'
import * as routes from 'core/routing/constants/index'
import PriceFrom from 'core/layouts/price-from'
import { configuratorShape, finishesShape } from '../../shapes'
import { greys } from '../../../assets/themes/theme-default'

const StyledCard = styled(Card)`
  &&& {
    margin: 15px 10px;
    box-shadow: ${props => props.selected && `0 2px 15px rgba(0,0,0,0.4)`};
    .ant-card-body {
      padding-top: 0;
    }
    .ant-card-actions {
      background: ${props => props.selected && props.theme.colors.color1.bg};
      > li > span {
        color: ${greys.light4};
        :hover {
          color: ${greys.light4};
        }
      }
    }
  }
`

const OptionsWrapper = styled.div`
  height: 300px;
  overflow-y: auto;
  margin: 20px 0;
  padding-right: 10px;
`

const FinishesCard = props => {
  const {
    item,
    handleClickShowEquipment,
    configurator,
    setConfigurator,
    setWizards,
    wizards,
    history
  } = props

  const { finishes } = configurator

  const getCardAction = () => <PriceFrom value={item.price} />

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_FINISHES) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)

    history.push(extendedStep.hash)
  }

  const desactivateNextSteps = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const currentIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_FINISHES)

    const steps = aStepsActive.map((step, index) => {
      let returnedStep = step
      if (index > currentIndex) returnedStep = { ...step, isActive: false }

      return returnedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: steps }

    setWizards(extentedWizards)
  }

  const handleOnChangeSelection = async () => {
    const motor = _.isEqual(item, configurator.finishes) ? configurator.motor : null

    const motorsList = _.isEqual(item, configurator.finishes) ? configurator.motorsList : null
    if (!_.isEqual(item, configurator.finishes)) await desactivateNextSteps()

    const extentedConfigurator = {
      ...configurator,
      finishes: item,
      price: item.price,
      motorsList,
      motor
    }

    setConfigurator(extentedConfigurator)
    activateNextStep()
  }

  return (
    <StyledCard
      hoverable
      bordered={false}
      title={item.title}
      actions={[getCardAction()]}
      onClick={e => {
        e.preventDefault()

        handleOnChangeSelection()
      }}
      selected={!finishes ? false : item.title === finishes.title}
    >
      <OptionsWrapper>
        {item.items &&
          item.items.map(el => (
            <div key={el.title}>
              <TitleItem>{el.title}</TitleItem>
              <p>{el.description}</p>
            </div>
          ))}
      </OptionsWrapper>
      <ButtonGhost
        type="primary"
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          handleClickShowEquipment(item.id)
        }}
        style={{ width: '100%' }}
      >
        <FormattedMessage id="configurator-finishes-button-1" />
      </ButtonGhost>
    </StyledCard>
  )
}

FinishesCard.propTypes = {
  item: finishesShape.isRequired,
  handleClickShowEquipment: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  wizards: wizardsShape.isRequired,
  setWizards: PropTypes.func.isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired
}

export default withRouter(FinishesCard)
